// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  language_default: 'en',
  second_title: ' | XRSupport',
  password_min_length: 8,
  api: {
    base_url : "https://test-api.xrsupport.online/api/v1",
    url_connect_check: "https://streaming.digitalmens.dev/backoffice/connections"
  },
  nodeHost: 'https://streaming.digitalmens.dev',
  websocket: {
    url_web_socket: "wss://streaming.digitalmens.dev",
    broadcast_channel: "xrsupport-channel"
  },
  saveScreenshotOnServer: true,
  saveLocallyScreenshot: false,
  // Face blur available from its button, but off when the call starts
  mustBlur: false,
  // The test signaling server never answers /backoffice/speech-log (504): don't send the transcripts there
  isSpeechLogEnabled: false,
  // The panel asks the headset for H264 (hardware compression on the headset) instead of VP8 (software)
  preferredVideoCodec: 'video/H264',
  home_page: '/dashboard',
  avatar_url: '/assets/images/users/user-img.jpg',
  file_accepted_files: [
    'application/pdf',
    'image/jpeg',
    'image/png',
  ],
  // TURN di test su OVH (lo stesso del visore): senza, il default punta a turn.digitalemens.dev che non esiste
  rtcConfig: {
    sdpSemantics: 'unified-plan',
    iceServers: [
      {
        urls: [
          'turn:turn.digitalmens.dev:3478',
          'turn:turn.digitalmens.dev:3478?transport=tcp'
        ],
        username: 'turn_digital',
        credential: 'Digital_2024!'
      },
      {
        urls: 'stun:stun.l.google.com:19302'
      }
    ]
  },
  language_list: [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Italiano',
      code: 'it',
      icon: '/assets/images/flag/icon-flag-it.svg',
    },
    {
      language: 'Deutsch',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ]
};
